'use client'

import {useFormContext} from 'react-hook-form'

import type {CaptchaRenderProps, CodeFormData} from '@/src/features/auth/core/login-types'
import {useCountdown} from '@/src/features/auth/model/use-countdown'

import {useCaptcha} from '@/src/shared/modules/captcha'

type UseCodeFormSubmitParams = {
  onConfirm: (params: {code: string; phone: string; token: string}, callbacks?: {onError?: (error: Error) => void}) => void
  phone: string
  interval: number
}

type UseCodeFormSubmitResult = {
  onSubmit: () => void
  remaining: number
  isTokenReady: boolean
  captchaProps: CaptchaRenderProps
}

export const useCodeFormSubmit = ({onConfirm, phone, interval}: UseCodeFormSubmitParams): UseCodeFormSubmitResult => {
  const form = useFormContext<CodeFormData>()
  const {token, onSuccessToken, visibleCaptcha, setVisibleCaptcha, renderKey, reset} = useCaptcha()
  const remaining = useCountdown(interval)

  const onSubmit = form.handleSubmit(() => {
    onConfirm(
      {...form.getValues(), phone, token: token!},
      {
        onError() {
          reset()
        },
      },
    )
  })

  return {
    onSubmit,
    remaining,
    isTokenReady: !!token,
    captchaProps: {
      renderKey,
      onSuccess: onSuccessToken,
      visible: visibleCaptcha,
      setVisible: setVisibleCaptcha,
    },
  }
}
